<template>
     <div class="record-item">
        <PageTitle icon="fa fa-folder-o" :main="item.name" sub="Registro do Item" />
            <b-form  >
             <input id="item-id" type="hidden" v-model="item.id" />
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group label="Nome:" label-for="item-name">
                        <b-form-input id="item-name" type="text" ref="searchFocus"
                            v-model="item.name" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Nome do Item..." />
                    </b-form-group>
                </b-col>    
                <b-col md="2" sm="12">    
                     <b-form-group label="Código Interno:" label-for="item-internal">
                        <b-form-input id="item-internal_code" type="text"
                            v-model="item.internal_code" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Código..." />
                    </b-form-group>
                </b-col>
                  <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="item.stock" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="item-stock"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="item-stock">
                                Estoque?
                            </label>
                        </div>
                    </div>
                    </b-col> 
                    <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="item.service" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                v-show="item.stock ? false: true"
                                id="item-service"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="item-service">
                                Serviço?
                            </label>
                        </div>
                    </div>
                    </b-col> 
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="item.blocked" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="item-blocked"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="item-blocked">
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>  
              
             </b-row>
             <b-row>
                <b-col md="6" sm="12">
                <b-form-group 
                    label="Decrição do Item:" 
                    label-for="item-description">
                    <b-form-textarea 
                        id="item-description"
                        :rows="3"
                        :max-rows="6"
                        size="sm"
                        v-model="item.description"
                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        placeholder="" />
                </b-form-group>
                </b-col>
            </b-row>
             <b-row>
                  <b-col md="3" sm="12">    
                     <b-form-group 
                        label="NCM:" 
                        label-for="item-ncm">
                        <b-form-input 
                            id="item-ncm" 
                            type="text"
                            v-model="item.ncm" 
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Código NCM..." />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">    
                     <b-form-group 
                        label="CEST:" 
                        label-for="item-cest">
                        <b-form-input 
                            id="item-cest" 
                            type="text"
                            v-model="item.cest" 
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Código CEST..." />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                <b-form-group 
                    label="Unidade:" 
                    label-for="item-unit_measure_id">
                    <b-form-select 
                        id="item-unit_measure_id"
                        size="sm"
                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        :options="unitmeasures" 
                        v-model="item.unit_measure_id" />
                </b-form-group>

                </b-col>
            </b-row>
            <b-row>
               <b-col md="8" sm="12">
                    <b-form-group 
                        label="Nome Completo:" 
                        label-for="item-complements_name">
                        <b-form-input 
                            id="item-complements_name" 
                            type="text" 
                            v-model="item.complements_name"
                            size="sm"
                            :readonly="true"
                            placeholder="Nome do Item Completo..." />
                    </b-form-group>
                </b-col>   
            </b-row>
         </b-form>
            <b-row>
                <b-col xs="12">
                    <b-button 
                         size="sm" 
                         btn-sm 
                         title="Retornar a pesquisa de itens."
                         variant="dark" 
                         class="ml-2 mb-2 fa fa-reply" 
                        @click="goback">
                    </b-button>         
                </b-col>
            </b-row>
         <b-row>
            <b-card no-body>   
                 <b-tabs card>
                    <b-tab title="Estoque" active>
                         <b-button  
                            size="sm" 
                            v-b-modal.modalStock  
                            @click="this.itemsStock = {}" 
                            variant="dark" 
                            class="mr-2 mb-2 fa fa-plus" 
                         ></b-button>
                        <b-table 
                            class="table-responsive" 
                            hover
                            sticky-header 
                            head-variant="light" 
                            key="slide"
                            :items="itemsStocks" 
                            :fields="fieldsStock">
                        <template v-slot:cell(actions)="data">
                                <b-button  
                                    size="sm" 
                                    v-b-modal.modalStock 
                                    variant="light" 
                                    @click="loadItemStock(data.item)" 
                                    class="mr-2 mt-2 fa fa-pencil">
                                </b-button>
                                <b-button  
                                    size="sm" 
                                    title="Registrar Movimentação de Estoque" 
                                    @click="loadItemStockInventoryMovement(data.item)" 
                                    v-b-modal.modalInventoryMovement 
                                    variant="light" 
                                    class="mr-2 mt-2 fa fa-plus-circle">
                                </b-button>
                                <b-button  
                                    title = "Estoque em Aprovação" 
                                    size="sm" 
                                    variant="light" 
                                    @click="loadInventoryMovementNotClosed()" 
                                    v-b-modal.modalInventoryMovementNotClosed 
                                    class="mr-2 mt-2 fa fa-drivers-license-o">
                                </b-button>
                            </template>   
                        </b-table> 
                    </b-tab>
                     <b-tab title="Tabela de Preço">
                          <b-button  
                          size="sm" 
                          v-b-modal.modalPrice  
                          @click="this.itemsprice = {}" 
                          variant="dark" 
                          class="mr-2 mb-2 fa fa-plus"> 
                         </b-button>
                         <b-table 
                            class="table-responsive" 
                            hover 
                            sticky-header 
                            head-variant="light" 
                            key="slide" 
                            :items="itemsprices" 
                            :fields="fieldsPrice">
                        <template v-slot:cell(actions)="data">
                                <b-button  
                                    size="sm" 
                                    v-b-modal.modalPrice 
                                    variant="light" 
                                    @click="loadItemPrice(data.item)" 
                                    class="mr-2 mt-2 fa fa-pencil">
                                </b-button>
                                <b-button  
                                    size="sm" 
                                    variant="light" 
                                    @click="modePrice = 'remove'" 
                                    class="mr-2 mt-2 fa fa-trash"
                                    v-if="modePrice === 'insert'"
                                >
                                </b-button>
                                <b-button  
                                    size="sm" 
                                    variant="light" 
                                    @click="[RemoveItemPrice(data.item),modePrice = 'insert']" 
                                    class="mr-2 mt-2 fa fa-check"
                                    v-if="modePrice === 'remove'"
                                >
                                </b-button>
                                <b-button  
                                    size="sm" 
                                    variant="light" 
                                    @click="modePrice = 'insert'" 
                                    class="mr-2 mt-2 fa fa-times"
                                    v-if="modePrice === 'remove'"
                                >
                                </b-button>
                                <span class="mr-2 mt-2"  v-if="modePrice === 'remove'" >Deseja Excluir o registro?</span>

                            </template>   
                        </b-table> 
                     </b-tab>
                 </b-tabs>    
            </b-card>
         </b-row>
        <b-modal id="modalStock"
            ref="modal"
            title-tag = "h6"
            title="Registro de Estoque"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveItemStock"
            >
           <b-form>
               <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group 
                            label="Empresa:" 
                            label-for="itemsStock-company_id">
                            <b-form-select 
                            id="itemsStock-company_id"
                            size="sm"
                            :options="companys" 
                            v-model="itemsStock.company_id" />
                        </b-form-group>
                    </b-col>
               </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                         <b-form-group 
                            label="Tipo de Estoque:" 
                            label-for="itemsStock-type_stock_id">
                            <b-form-select 
                            id="itemsStock-type_stock_id"
                            size="sm"
                            :options="typestocks" 
                            v-model="itemsStock.type_stock_id" />
                        </b-form-group>
                    </b-col>
               </b-row>
               <b-row>
                     <b-col md="12" sm="12">
                        <b-form-group 
                            label="Localidade:" 
                            label-for="itemsStock-location">
                            <b-form-input 
                            id="itemsStock-location" 
                            type="text"
                            v-model="itemsStock.location" 
                            size="sm"
                            placeholder="Localidade..." />
                        </b-form-group>
                    </b-col>
               </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Qtde. Mínima:" 
                            label-for="itemsStock-minimum_quantity">
                        <b-form-input 
                            id="itemsStock-minimum_quantity" 
                            v-model="itemsStock.minimum_quantity" 
                            type="number"
                             size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group 
                            label="Qtde. Máxima:" 
                            label-for="itemsStock-maximum_quantity">
                        <b-form-input 
                            id="itemsStock-maximum_quantity" 
                            v-model="itemsStock.maximum_quantity" 
                            type="number"
                             size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="5" sm="12">
                        <b-form-group 
                            label="Data Validade:" 
                            label-for="itemsStock-expiration_date">
                        <b-form-input 
                            id="itemsStock-expiration_date" 
                            type="date"
                            v-model="itemsStock.expiration_date" 
                            size="sm"
                        />
                        </b-form-group>
                    </b-col> 
                    <b-col md="3" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" v-model="itemsStock.blocked" true-value="1" false-value="0" type="checkbox" id="itemsStock-blocked"
                                >
                                <label class="form-check-label" for="itemsStock-blocked">
                                    Bloqueado?
                                </label>
                            </div>
                        </div>
                    </b-col> 
                </b-row>
           </b-form>

        </b-modal>
        <b-modal id="modalPrice"
            ref="modal"
            title-tag = "h6"
            title="Registro de Tabela de Preço"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveItemPrice"
            >
           <b-form>
               <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group 
                            label="Empresa:" 
                            label-for="itemsprice-company_id">
                            <b-form-select id="itemsprice-company_id"
                            size="sm"
                            :options="companys" 
                            v-model="itemsprice.company_id" />
                        </b-form-group>
                    </b-col>
               </b-row>
               <b-row>
                    <b-col md="12" sm="12">
                         <b-form-group 
                            label="Tabela de Preço:" 
                            label-for="itemsprice-type_price_id">
                            <b-form-select 
                            id="itemsprice-type_price_id"
                            size="sm"
                            :options="typeprices" 
                            v-model="itemsprice.type_price_id" />
                        </b-form-group>
                    </b-col>
               </b-row>
                <b-row>
                    <b-col md="5" sm="12">
                        <b-form-group 
                            label="Data de Início:" 
                            label-for="itemsprice-start_date">
                        <b-form-input 
                            id="itemsprice-start_date" 
                            type="date"
                            v-model="itemsprice.start_date" 
                            size="sm"
                        />
                        </b-form-group>
                    </b-col> 
                    <b-col md="5" sm="12">
                        <b-form-group label="Data de Termino:" label-for="itemsprice-end_date">
                        <b-form-input id="itemsprice-end_date" type="date"
                            v-model="itemsprice.end_date" 
                            size="sm"
                        />
                        </b-form-group>
                    </b-col> 
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group label="Valor Unitário:" label-for="itemsprice-price_sale">
                        <b-form-input id="itemsprice-price_sale" 
                            v-model="itemsprice.price_sale" 
                            type="number"
                            step="0.02"
                             size="sm"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input 
                                    class="form-check-input" 
                                    v-model="itemsprice.blocked" 
                                    true-value="1" 
                                    false-value="0" 
                                    type="checkbox" 
                                    id="itemsprice-blocked"
                                >
                                <label class="form-check-label" for="itemsprice-blocked">
                                    Bloqueado?
                                </label>
                            </div>
                        </div>
                    </b-col> 
                </b-row>
           </b-form>

        </b-modal>
        <b-modal id="modalInventoryMovement"
            ref="modal"
            title-tag = "h6"
            title="Registro de Movimentação de Estoque"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveInventoryMovement"
            >
            <b-form>
                 <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group 
                            label="Data:" 
                            label-for="inventorymovement-inventory_date">
                            <b-form-input 
                            id="inventorymovement-inventory_date" 
                            type="date"
                            v-model="inventorymovement.inventory_date" 
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                            <div class="form-group">
                                <div class="form-check">
                                    <input 
                                        class="form-check-input" 
                                        v-model="inventorymovement.inventory_input" 
                                        true-value="1" 
                                        false-value="0" 
                                        type="checkbox" 
                                        id="inventorymovement-inventory_input"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                    >
                                    <label 
                                        class="form-check-label" 
                                        for="inventorymovement-inventory_input">
                                        Entrada?
                                    </label>
                                </div>
                            </div>
                    </b-col>  
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group 
                            label="Qtde.:" 
                            label-for="inventorymovement-quantity_stock">
                        <b-form-input 
                            id="inventorymovement-quantity_stock" 
                            v-model="inventorymovement.quantity_stock" 
                            type="number"
                            size="sm"
                            ref="focusThis"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group 
                            label="Valor:" 
                            label-for="inventorymovement-price_stock_value">
                        <b-form-input 
                            id="inventorymovement-price_stock_value" 
                            v-model="inventorymovement.price_stock_value" 
                            type="number"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>  
                </b-row>
                <b-row>
                    <b-col md="10" sm="12">
                        <b-form-group 
                            label="Observação:" 
                            label-for="inventorymovement-comments_inventory">
                            <b-form-textarea 
                                id="inventorymovement-comments_inventory"
                                :rows="2"
                                :max-rows="6"
                                size="sm"
                                v-model="inventorymovement.comments_inventory"
                                placeholder="" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
         </b-modal>   
          <b-modal id="modalInventoryMovementNotClosed"
            ref="modal"
            title-tag = "h6"
            size="xl"
            title="Registro de Movimentação de Estoque"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            >
            <b-form>
                <b-table 
                    class="table-responsive" 
                    hover key="slide" 
                    :items="inventorymovementsnotclosed" 
                    :fields="fieldsNotClosed">
                    <template v-slot:cell(actions)="data">
                        <b-button  
                            title = "Aprovar movimentação de estoque do registro" 
                            size="sm" 
                            variant="light" 
                            @click="saveStockNotClosed(data.item)" 
                            class="mr-2 mt-2 fa fa-check-square">
                        </b-button>
                         <b-button  
                            size="sm" 
                            variant="light" 
                            @click="modeInventoryMovement = 'remove'" 
                            class="mr-2 mt-2 fa fa-trash"
                            v-if="modeInventoryMovement === 'insert'"
                        >
                        </b-button>
                        <b-button  
                            size="sm" 
                            variant="light" 
                            @click="[RemoveStockNotClosed(data.item),modeInventoryMovement = 'insert']" 
                            class="mr-2 mt-2"
                            v-if="modeInventoryMovement === 'remove'"
                        >
                            <i class="fa fa-check"></i>
                        </b-button>
                        <b-button  size="sm" variant="danger" @click="modeInventoryMovement = 'insert'" class="mr-2 mt-2"
                            v-if="modeInventoryMovement === 'remove'"
                        >
                            <i class="fa fa-times"></i>
                        </b-button>
                        <span class="mr-2 mt-2"  v-if="modeInventoryMovement === 'remove'" >Deseja Excluir o registro?</span>
                        </template>  
                </b-table> 
            </b-form>
          </b-modal>
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
var moment = require('moment')

export default {
    name: 'recordItem',
    directives: {moment},
    components: {PageTitle },
    data: function() {
        return {
                mode: 'read',
                modeStock: 'insert',
                modePrice: 'insert',
                modeInventoryMovement: 'insert',
                search: '',
                groupitem: {},
                item: {},
                itemsStock:{},
                itemsStocks:[],
                itemsprice:{},
                itemsprices:[],
                items: [],
                companys:[],
                typeprices:[],
                typestocks:[],
                unitmeasures: {},
                inventorymovement: {},
                inventorymovementsnotclosed: [],
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fieldsStock: [
                { key: 'name_company', label: 'Empresa', sortable: true },
                { key: 'type_stock_name', label: 'Tipo de Estoque', sortable: false },
                { key: 'location', label: 'Localidade', sortable: false },
                { key: 'stock_quantity', label: 'Qtde Estoque.', sortable: false },
                { key: 'minimum_quantity', label: 'Qtde Mín.', sortable: false },
                { key: 'maximum_quantity', label: 'Qtde Max.', sortable: false },
                { key: 'price_unit_stock', label: 'Vr. Custo Unitário', sortable: false },      
                { key: 'blocked', label: 'Bloqueado', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },               
                { key: 'actions', label: 'Ações' }
                ],
                fieldsPrice: [
                { key: 'name_company', label: 'Empresa', sortable: true },
                { key: 'name_type_price', label: 'Tabela de Preço.', sortable: false },
                { key: 'start_date', label: 'Data de Início.', sortable: false,
                    formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '')
                 },
                { key: 'end_date', label: 'Data de Termino.', sortable: false,
                    formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '')
                 },
                { key: 'price_sale', label: 'Vr. Venda Unitário', sortable: false },      
                { key: 'blocked', label: 'Bloqueado', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },               
                { key: 'actions', label: 'Ações' }
                ],
                 fieldsNotClosed: [
                { key: 'inventory_date', label: 'Movimentado em', sortable: false,
                   formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '') },  
                { key: 'name_company', label: 'Empresa', sortable: false },      
                { key: 'complements_name', label: 'Item', sortable: false },  
                { key: 'location', label: 'Complemento', sortable: false },
                { key: 'initials', label: 'Unid.', sortable: false },  
                { key: 'inventory_input', label: 'Entrada', sortable: false,
                    formatter: value => value ? 'Sim' : 'Não'},  
                { key: 'quantity_stock', label: 'Qtde.', sortable: false },    
                { key: 'price_stock_value', label: 'Valor', sortable: false },       
                { key: 'actions', label: 'Ações' }
                ],
            }
        },
        computed:{
            user(){
                return this.$store.state.user
            },
            compan(){
                return this.$store.state.compan
            },
        },
        methods:{
            goback(){
                 this.$router.go(-1, {query: 'q=s', hash: 'hashFrag'})
            }, 
             getItem(){
                const url = `${baseApiUrl}/items/${this.item.id}`
                axios(url).then(res=> this.item = res.data)
            },
            formatDate (date) {
                return moment.utc(date).format('YYYY-MM-DD')
            },
            getItems(){
                const url = `${baseApiUrl}/groupitems/${this.groupitem.id}/items`
                axios(url).then(res =>{
                     this.items = res.data
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.item = {}
                    this.$refs.searchFocus.focus();
            },
            reset() {
                this.mode = 'insert'
            },
            saveItem() {
                const method = this.item.id ? 'put' : 'post'
                const id = this.item.id ? `/${this.item.id}` : ''
                axios[method](`${baseApiUrl}/items${id}`, this.item)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.getItem()
                    })
                    .catch(showError)
            },
            saveItemStock() {
                const method = this.itemsStock.id ? 'put' : 'post'
                const id = this.itemsStock.id ? `/${this.itemsStock.id}` : ''
                if(this.item.id){
                    this.itemsStock.item_id = this.item.id
                }
                axios[method](`${baseApiUrl}/itemsstock${id}`, this.itemsStock)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.itemsStock = {}
                        this.loadItemStocks()
                    })
                    .catch(showError)
            },
            loadItemStock(itemsStock){

                if(itemsStock.expiration_date) itemsStock.expiration_date = this.formatDate(itemsStock.expiration_date)

                 this.itemsStock = { ...itemsStock }
            },
            loadItemStocks(){
                const url = `${baseApiUrl}/itemsstock/${this.item.id}/items`
                axios(url).then(res =>{
                     this.itemsStocks = res.data
                })
            },
            RemoveItemStock(itemsStock) {
                    const id = itemsStock.id
                    axios.delete(`${baseApiUrl}/itemsstock/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadItemStocks()
                        })
                        .catch(showError)
            },
            saveItemPrice() {
                const method = this.itemsprice.id ? 'put' : 'post'
                const id = this.itemsprice.id ? `/${this.itemsprice.id}` : ''
                if(this.item.id){
                    this.itemsprice.item_id = this.item.id
                }
                axios[method](`${baseApiUrl}/itemsprice${id}`, this.itemsprice)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadItemPrices()
                    })
                    .catch(showError)
            },
            loadItemPrices(){
                const url = `${baseApiUrl}/itemsprice/${this.item.id}/items`
                axios(url).then(res =>{
                     this.itemsprices = res.data
                })
            },
            loadItemPrice(itemsprice){

                 if(itemsprice.start_date) itemsprice.start_date = this.formatDate(itemsprice.start_date)
                if(itemsprice.end_date) itemsprice.end_date = this.formatDate(itemsprice.end_date)

                 this.itemsprice = { ...itemsprice }
            },
            RemoveItemPrice(itemsprice) {
                    const id = itemsprice.id
                    axios.delete(`${baseApiUrl}/itemsprice/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadItemPrices()
                        })
                        .catch(showError)
            },
            loadUnitMeasure() {
                    const url = `${baseApiUrl}/unitmeasures`
                    axios.get(url).then(res => {
                        this.unitmeasures = res.data.map(unitmeasure => {
                            return { value: unitmeasure.id, text: unitmeasure.initials }
                        })
                    })
            },
            loadCompanys() {
                    const url = `${baseApiUrl}/companys`
                    axios.get(url).then(res => {
                        this.companys = res.data.map(company => {
                            return { value: company.id, text: company.name_company }
                        })
                    })
                },
            loadTypePrices() {
                const url = `${baseApiUrl}/typeprice`
                axios.get(url).then(res => {
                    this.typeprices = res.data.map(typeprice => {
                        return { value: typeprice.id, text: typeprice.name_type_price }
                    })
                })
            },   
            loadTypeStocks() {
                const url = `${baseApiUrl}/typestocks`
                axios.get(url).then(res => {
                    this.typestocks = res.data.map(typestock => {
                        return { value: typestock.id, text: typestock.type_stock_name }
                    })
                })
            },   
            loaditem(item, mode = 'save') {
                this.mode = mode
                this.item = { ...item }
                this.$refs.searchFocus.focus();
            },
            loadItemStockInventoryMovement(itemstock){

                const date = new Date() 
                this.inventorymovement= {}

                this.inventorymovement.inventory_date = moment.utc(date).format('YYYY-MM-DD')
                this.inventorymovement.company_id = itemstock.company_id
                this.inventorymovement.item_id = itemstock.item_id
                this.inventorymovement.item_stock_id = itemstock.id
                this.inventorymovement.inventory_input = 1
            },
            saveInventoryMovement() {
                this.inventorymovement.user_id = this.user.id   
                
                const method = this.inventorymovement.id ? 'put' : 'post'
                const id = this.inventorymovement.id ? `/${this.inventorymovement.id}` : ''
                axios[method](`${baseApiUrl}/inventorymovements${id}`, this.inventorymovement)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    })
                    .catch(showError)
            },
            loadInventoryMovementNotClosed() {

                const url = `${baseApiUrl}/inventorymovementsnotclosed`
                axios.get(url).then(res => {
                    this.inventorymovementsnotclosed = res.data
                })
            },
            saveStockNotClosed(inventorymovement) {
                    
                const method = 'post'
                const id = `/${inventorymovement.id}`
                axios[method](`${baseApiUrl}/inventorymovementstock${id}`)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadInventoryMovementNotClosed()
                    this.loadItemStocks()
                    })
                    .catch(showError)
            },
            RemoveStockNotClosed(inventorymovement) {
                    const id = inventorymovement.id
                    axios.delete(`${baseApiUrl}/inventorymovements/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadInventoryMovementNotClosed()
                        })
                        .catch(showError)
            },
        },
        watch:{
            $route(to){
                this.item.id = to.params.id
                this.item = {}
                this.getItem()
                this.getItems()
            }
        },
        mounted(){
            this.item.id = this.$route.params.id
            this.getItem()
            this.getItems()
            this.loadUnitMeasure()
            this.loadTypeStocks()
            this.loadCompanys()
            this.loadTypePrices()
            this.loadItemStocks()
            this.loadItemPrices()
        }
}
</script>

<style>

    .record-item {
        font-size: 0.75rem;
   
    }
    .record-item select,label {
        font-size: 0.75rem;
    }

    .record-item button {
        font-size: 0.75rem;
    }

    .record-item textarea {
        font-size: 0.75rem;
    }

    .record-item input {
        font-size: 0.75rem;
    }

    #modalStock{
       font-size: 0.75rem;
    }

    #modalStock button{
       font-size: 0.75rem;
    }

    #modalStock select{
       font-size: 0.75rem;
    }

    #modalStock input{
       font-size: 0.75rem;
    }

    #modalPrice {
        font-size: 0.75rem;
    }

    #modalPrice button{
        font-size: 0.75rem;
    }

    #modalPrice select{
        font-size: 0.75rem;
    }

    #modalPrice input{
        font-size: 0.75rem;
    }

     #modalInventoryMovement {
        font-size: 0.75rem;
    }

    #modalInventoryMovement button{
        font-size: 0.75rem;
    }

    #modalInventoryMovement select{
        font-size: 0.75rem;
    }

    #modalInventoryMovement input{
        font-size: 0.75rem;
    }

    #modalInventoryMovementNotClosed {
        font-size: 0.75rem;
    }

    #modalInventoryMovementNotClosed button{
        font-size: 0.75rem;
    }

    #modalInventoryMovementNotClosed select{
        font-size: 0.75rem;
    }

    #modalInventoryMovementNotClosed input{
        font-size: 0.75rem;
    }
    

</style>
